import { useTheme } from "@emotion/react";
import { useEffect, useState, type FC, type PropsWithChildren } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { LuCircleCheck } from "react-icons/lu";

import { Box, Input, Field, Icon } from "@chakra-ui/react";
import { Tabs, TabsPanel, TabType } from "@mtb/mtb-ui";

const FieldLabel = Field.Label as FC<PropsWithChildren>;

type ContentType = {
  title: string;
  tags: string;
  language: string;
};

type FormValues = {
  content: ContentType[];
};

export const LanguageTestPage = () => {
  const { i18n, t } = useTranslation("common");
  const theme = useTheme();

  const [tabIndex, setTabIndex] = useState(0);
  const [tabs, setTabs] = useState<TabType[]>([]);

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
  };

  const languages =
    (i18n &&
      i18n.options &&
      i18n.options.supportedLngs &&
      i18n.options.supportedLngs.filter((lng: any) => lng !== "cimode")) ||
    [];

  const contentDefaultValues = languages?.map((language: string) => ({
    title: "",
    tags: "",
    icon: "",
    language: language,
  }));

  const { register, control } = useForm<FormValues>({
    defaultValues: {
      content: contentDefaultValues,
    },
    mode: "onBlur",
  });

  const updatedData: any = useWatch({
    control,
  });

  useEffect(() => {
    updatedData &&
      setTabs(
        updatedData.content?.map((data: any) => ({
          label: getLanguageLabel(data.language),
          icon:
            data.tags !== "" && data.title !== "" ? (
              <Icon as={LuCircleCheck} ml={2} w={4} h={4} color={theme.colors.primary} />
            ) : null,
        }))
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);

  const getLanguageLabel = (lng: string) =>
    lng === "en"
      ? t("languages.english")
      : lng === "nl"
      ? t("languages.dutch")
      : lng === "es"
      ? t("languages.spanish")
      : lng === "de"
      ? t("languages.german")
      : lng === "fr"
      ? t("languages.french")
      : "";

  return (
    <Box width="700px" p="30">
      <Tabs
        title="Algemene info"
        currentTab={tabIndex}
        handleTabsChange={handleTabsChange}
        tabs={tabs}
      >
        <TabsPanel value={String(tabIndex)}>
          <Field.Root mb="4">
            <FieldLabel>Title</FieldLabel>
            <Input
              key={`content.${tabIndex}.title`}
              {...register(`content.${tabIndex}.title` as const)}
            />
          </Field.Root>
          <Field.Root mb="4">
            <FieldLabel>Tags</FieldLabel>
            <Input
              key={`content.${tabIndex}.tags`}
              {...register(`content.${tabIndex}.tags` as const)}
            />
          </Field.Root>
        </TabsPanel>
      </Tabs>
    </Box>
  );
};
